import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout";
import { RequireAuth } from "./components/RequireAuth";
import { Approvals } from "./pages/Approvals";
import { ContainerDetail } from "./pages/ContainerDetail";
import { Containers } from "./pages/Containers";
import { History } from "./pages/History";
import { Login } from "./pages/Login";
import { Marketplaces } from "./pages/Marketplaces";
import { Panoramica } from "./pages/Panoramica";
import { Products } from "./pages/Products";
import { Settings } from "./pages/Settings";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

export default function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<RequireAuth />}>
            <Route element={<Layout />}>
              <Route index element={<Panoramica />} />
              <Route path="prodotti" element={<Products />} />
              <Route path="products" element={<Navigate to="/prodotti" replace />} />
              <Route path="container" element={<Containers />} />
              <Route path="container/:code" element={<ContainerDetail />} />
              <Route path="marketplaces" element={<Marketplaces />} />
              <Route path="approvals" element={<Approvals />} />
              <Route path="history" element={<History />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
